import { calculateMonthlyPayTotal, countUniqueMonthlyPayRecords, roundCurrency } from "./CalculateMonthlyPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    Gross_Pay: number | string | null;
}

const CalculateAnnualGrossPay = (payRecords: payRecords[]) => {
    if (!Array.isArray(payRecords)) {
        return 0;
    }

    const mappedGrossPayRecords = payRecords.map(file => ({ ...file, Pay: file.Gross_Pay }));
    const monthlyPayTotal = calculateMonthlyPayTotal(mappedGrossPayRecords, false);
    if (monthlyPayTotal === 0) {
        return 0;
    }

    const includedRecordCount = countUniqueMonthlyPayRecords(mappedGrossPayRecords);
    const averageMonthlyPay = includedRecordCount ? monthlyPayTotal / includedRecordCount : monthlyPayTotal;

    return roundCurrency(averageMonthlyPay * 12);
}

export default CalculateAnnualGrossPay;
